import React, { Component } from "react";
import Slide from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "red" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "green" }}
      onClick={onClick}
    />
  );
}

export default class Slider extends Component {
  render() {
    let slideData = this.props.slideData || [
      <h1>1</h1>,
      <h1>2</h1>,
      <h1>3</h1>,
      <h1>4</h1>,
      <h1>5</h1>,
    ];
    const settings = {
      // dots: true,
      // infinite: true,
      // slidesToShow: 3,
      // slidesToScroll: 1,
      // nextArrow: <SampleNextArrow />,
      // prevArrow: <SamplePrevArrow />,
      ...this.props.settings,
    };
    return (
      <div className={this.props.className}>
        {/* <h2>Custom Arrows</h2> */}
        <Slide {...settings}>
          {slideData.map((x , index) => (
            <div key={index}>{x}</div>
          ))}
        </Slide>
      </div>
    );
  }
}
